module.exports = __webpack_public_path__ + "static/media/icon-compare.2cce24cd.svg";